import { InlineNotification } from '@carbon/react';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { TractNRI } from 'components/nri-table/types';
import {
  SlotAllocationsSummary,
  SlotsSummary,
  SlotSummaryRow,
  SlotSummaryDisplayMode,
} from 'components/slot-summary-table';
import { entitySlotSummaryDataAtom } from './atoms';

interface EntitySlotSummaryProps {
  entityId: number;
  displayMode?: SlotSummaryDisplayMode;
}

export const EntitySlotSummary = ({
  entityId,
  displayMode = 'none',
}: EntitySlotSummaryProps) => {
  const slotSummaryTabData = useLoadableAtomValue<
    { slotSummary: SlotSummaryRow[]; slots: TractNRI[] },
    Error
  >(entitySlotSummaryDataAtom(entityId));

  const isLoading = slotSummaryTabData.state === 'loading';
  const hasError = slotSummaryTabData.state === 'hasError';
  const { slotSummary, slots } =
    slotSummaryTabData.state === 'hasData'
      ? slotSummaryTabData.data
      : { slotSummary: [], slots: [] };

  return (
    <>
      {hasError && (
        <InlineNotification
          kind="error"
          title={slotSummaryTabData.error.message}
          lowContrast
        />
      )}
      {displayMode === 'slots' ? (
        <SlotsSummary
          slotSummary={slotSummary}
          slots={slots}
          isLoading={isLoading}
          showHighlight={false}
          tableId={`entity-slots-summary-${entityId}`}
        />
      ) : (
        <SlotAllocationsSummary
          slotSummary={slotSummary}
          slots={slots}
          isLoading={isLoading}
          showHighlight={false}
          tableId={`entity-slot-allocations-summary-${entityId}`}
        />
      )}
    </>
  );
};
